export const cssName = name =>
  name && encodeURIComponent(name).replace(/%[0-9A-F]{2}/gi, '')
